import './App.css';
import React, { useEffect } from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import { Cloudpayments } from 'cp-core';
import Home from 'pages/Home/Home';
import Login from 'pages/Auth/Login';
import Layout from 'components/Common/Layout';
import SendAnnouncement from 'pages/Annoucement/SendAnnouncement';
import ForgotPassword from 'pages/Auth/ForgotPassword';
import SendInvoice from 'pages/Invoice/SendInvoice';
import Staff from 'pages/Staff/Staff';
import CreateNewStaff from 'pages/Staff/CreateNewStaff';
import MyAccount from 'pages/Account/MyAccount';
import MyAccountEditInfo from 'pages/Account/MyAccountEditInfo';
import MyAccountChangePassword from 'pages/Account/MyAccountChangePassword';
import BasketDetail from 'pages/Home/BasketDetail';
import BasketWithdrawFundBalance from 'pages/Home/BasketWithdrawFundBalance';
import CreateBasket from 'pages/Home/CreateBasket';
import AccountChangePhoto from 'pages/Account/AccountChangePhoto';
import routes from 'constants/routes';
import Community from 'pages/Community/Community';
import ParishonerDetail from 'pages/Community/ParishonerDetail';
import TransactionDetails from 'pages/Community/TransactionDetails';
import IssueRefund from 'pages/Community/IssueRefund';
import Wallet from 'pages/Wallet/Wallet';
import ParishonerWallet from 'pages/Wallet/ParishWallet';
import WithdrawToBank from 'pages/Wallet/WithdrawToBank';
import WalletBaskets from 'pages/Wallet/WalletBaskets';
import SendMoney from 'pages/Money/SendMoney';
import Announcements from 'pages/Annoucement/Announcements';
import AnnouncementDetails from 'pages/Annoucement/AnnouncementDetails';
import CreateAnnouncementGroup from 'pages/Annoucement/CreateAnnouncementGroup';
import AnnouncementGroupDetails from 'pages/Annoucement/AnnouncementGroupDetails';
import Parishes from 'pages/Parishes&Organizations/Parishes';
import OrganizationDetail from 'components/Parishes&Organizations/OrganizationDetails';
import { useDispatch } from 'react-redux';
import ProtectedRoute from 'auth/ProtectedRoute';
import { CPCommonPath, CommonPath } from 'cp-common';
import client from 'api/apiClient';
import { AppDispatch } from 'redux/store';
import ViewQRCode from 'pages/QR/ViewQRCode';
import NotFound from 'pages/NotFound/NotFound';
import ErrorBoundary from 'pages/ErrorBoundary';
import WalletInvoiceDetail from 'pages/Wallet/WalletInvoiceDetail';
import RequireMerchant from 'auth/RequireMerchant';
import UserDetail from 'pages/User/UserDetail';
import CreateAnnouncementContainer from 'pages/Annoucement/CreateAnnouncementContainer';
import EditAnnouncementContainer from 'pages/Annoucement/EditAnnouncementContainer';
import VerifyPinCode from 'pages/Auth/VerifyPinCode';
import TransactionDetailContainer from 'pages/Transaction/TransactionDetail';

const API_KEY = '5dbb36169aa4ad00019f7497b23138824d714d30a2f877bb336bd0e8';

function App() {
    let path: CommonPath = {
        verifyUser: 'catholic-ms/auth/getToken', //By default fundz-ms/user/getToken
        logout: 'catholic-ms/user/logout', //By default fundz-ms/user/logout
        /*login: "",               //By default auth/oauth/token
    signup: "",              //By default fundz-ms/userFull
    changePassword: "",      //By default auth/api/myinfo/changePassword
    forgotPassword: "",      //By default auth/api/reset/password
    policy: "",              //By default fundz-ms/getPolicy
    requestTwoFactor: "",    //By default fundz-ms/request2FAPin
    validateTwoFactor: "",   //By default fundz-ms/validate2FA
    registerDevice: "",      //By default fundz-ms/registerDevice
    uploadAvatar: "",        //By default fundz-ms/user/setMyPicture
    removeAvatar: "",        //By default fundz-ms/user/removeMyPicture
    addPhoneNumber: "",      //By default fundz-ms/user/setPhone
    removePhoneNumber: "",   //By default fundz-ms/user/removePhone
    resendCodeToPhone: "",   //By default fundz-ms/user/resendPin
    validatePhoneNumber: "", //By default fundz-ms/user/validatePhone
    updateUserStatus: "",    //By default fundz-ms/user/updateUserStatus
    validateEmail: "",       //By default fundz-ms/user/validatePin
    resendPinToEmail: "",    //By default fundz-ms/user/resendValidationPin*/
    };
    Cloudpayments.init('RCC', 'dev', 'web', API_KEY, 'catholic_app');
    CPCommonPath.init(path);

    const dispatch = useDispatch<AppDispatch>();

    useEffect(() => {
        client && client.setDispatch(dispatch);
    }, [dispatch]);

    return (
        <Router>
            <ErrorBoundary dispatch={dispatch}>
                <Routes>
                    {/* Login Route */}
                    <Route path={routes.auth.login} element={<Login />} />
                    {/* Forgot Password Route */}
                    <Route path={routes.auth.forgotPassword} element={<ForgotPassword />} />
                    <Route path={routes.auth.verifyPin} element={<VerifyPinCode />}></Route>
                    {/* Change Password Route */}
                    {/* Mounting outside the layout because it is used inside the layout and the auth layout so render layout conditionally based on the mounted component */}
                    <Route element={<ProtectedRoute />}>
                        <Route path={routes.account.changePassword} element={<MyAccountChangePassword />} />
                    </Route>

                    {/* Routes With Layout */}
                    <Route element={<Layout />}>
                        {/* Protected Routes */}
                        <Route element={<ProtectedRoute />}>
                            {/* Home Route */}
                            <Route path={routes.home.main} element={<Home />} />
                            {/* Send Invoice Route */}
                            <Route path={routes.sendinvoice.main} element={<SendInvoice />} />
                            {/* Send Money Route */}
                            <Route path={routes.sendmoney.main} element={<SendMoney />} />
                            {/* Home - Basket Details Active  */}
                            <Route path={routes.home.basketDetails} element={<BasketDetail />} />
                            {/* Home - Basket Details  */}
                            <Route path={routes.home.basketwithdrawbalance} element={<BasketWithdrawFundBalance />} />
                            {/* Home - Basket Create  */}
                            <Route path={routes.home.basketCreate} element={<CreateBasket />} />
                            {/* Home - Basket edit  */}
                            <Route path={routes.home.basketUpdate} element={<CreateBasket />} />

                            {/* Staff Route */}
                            <Route element={<RequireMerchant />}>
                                <Route path={routes.staff.main} element={<Staff />} />
                                <Route path={routes.staff.add} element={<CreateNewStaff />} />
                            </Route>

                            {/* User */}
                            <Route path={routes.user.userDetail} element={<UserDetail />} />

                            {/* My Account Route */}
                            <Route path={routes.account.main} element={<MyAccount />} />
                            <Route path={routes.account.edit} element={<MyAccountEditInfo />} />
                            <Route path={routes.account.changePhoto} element={<AccountChangePhoto />} />

                            {/* Community Route */}
                            <Route path={routes.community.main} element={<Community />} />
                            <Route path={routes.community.ParishonerDetails} element={<ParishonerDetail />} />
                            <Route path={routes.community.issueRefund} element={<IssueRefund />} />

                            {/* Announcements Route */}
                            <Route path={routes.announcements.main} element={<Announcements />} />
                            <Route path={routes.announcements.details} element={<AnnouncementDetails />} />
                            <Route path={routes.announcements.new} element={<CreateAnnouncementContainer />} />
                            <Route path={routes.announcements.edit} element={<EditAnnouncementContainer />} />
                            <Route path={routes.announcements.createGroup} element={<CreateAnnouncementGroup />} />
                            <Route path={routes.announcements.groupDetails} element={<AnnouncementGroupDetails />} />

                            {/* Wallet Route */}
                            <Route path={routes.wallet.main} element={<Wallet />} />
                            <Route path={routes.wallet.parishWallet} element={<ParishonerWallet />} />
                            <Route path={routes.wallet.withdrawToBank} element={<WithdrawToBank />} />
                            <Route path={routes.wallet.givingBasket} element={<WalletBaskets basketType="givingList" />} />
                            <Route path={routes.wallet.paymentBasket} element={<WalletBaskets basketType="paymentList" />} />

                            {/* Parish Wallet - Invoice Details */}
                            <Route path={routes.wallet.invoiceDetails} element={<WalletInvoiceDetail />} />

                            {/* Parishes & Organization - Archdiocese */}
                            <Route path={routes.parishes.main} element={<Parishes />} />
                            <Route path={routes.parishes.organizationDetails} element={<OrganizationDetail />} />

                            {/* QR Routes */}
                            <Route path={routes.qr.main} element={<ViewQRCode />} />

                            {/* Transaction Routes */}
                            <Route path={routes.transaction.main} element={<TransactionDetailContainer />} />
                        </Route>
                    </Route>
                    <Route path="*" element={<NotFound />} />
                </Routes>
            </ErrorBoundary>
        </Router>
    );
}

export default App;
